import { periodToQuery } from './reportPeriod'

import type { IReportPeriod, IReportSort, IReportUser } from '../Contracts/IReportPeriod'

/**
 * Спільне для трьох задач звітів: параметри запиту і зведення чисел.
 *
 * Бек віддає `int`/`float`, але відповідь приходить як `unknown`
 * (`restClient` типізований як `KyResponse`), тож кожне поле зводимо явно:
 * зіпсоване значення стає нулем, а не `NaN` у таблиці.
 */
export const reportSearchParams = (period: IReportPeriod, sort: IReportSort | null = null): Record<string, string> => ({
    ...periodToQuery(period),
    ...(sort !== null ? { [`order[${sort.field}]`]: sort.direction } : {}),
})

export const toNumber = (value: unknown): number => (typeof value === 'number' && Number.isFinite(value) ? value : 0)

export const toPeriod = (value: unknown, fallback: IReportPeriod): IReportPeriod => {
    const period = value as Partial<IReportPeriod> | null | undefined

    return {
        from: typeof period?.from === 'string' ? period.from : fallback.from,
        to: typeof period?.to === 'string' ? period.to : fallback.to,
    }
}

export const toReportUser = (value: unknown): IReportUser => {
    const user = value as Partial<IReportUser> | null | undefined

    return {
        uuid: String(user?.uuid ?? ''),
        fullName: typeof user?.fullName === 'string' ? user.fullName : null,
        isActive: user?.isActive !== false,
    }
}

export const toRows = (value: unknown): unknown[] => (Array.isArray(value) ? value : [])
